import {
  normalizeField,
  ensureString,
  ensureArray,
  parseBoolean,
  parseInteger,
} from '../base/BaseNormalizer';
import { validatePartiesResponse } from './validateMiddlePanelNormalization';

export const normalizePartyItem = (raw = {}) => {
  if (!raw || typeof raw !== 'object') {
    return null;
  }
  return {
    id: normalizeField(raw, ['Id'], null),
    entityId: normalizeField(raw, ['entityId'], null),
    entityType: ensureString(normalizeField(raw, ['entity_type'], '')),
    entityName: ensureString(normalizeField(raw, ['entity_name'], '')),
    entityNameTitle: ensureString(normalizeField(raw, ['entity_name_title'], '')),
    contactName: ensureString(normalizeField(raw, ['ContactName'], '')),
    orgName: ensureString(normalizeField(raw, ['OrgName'], '')),
    createdBy: ensureString(normalizeField(raw, ['CreatedBy'], '')),
    email: ensureString(normalizeField(raw, ['email'], '')),
    phone: ensureString(normalizeField(raw, ['phone'], '')),
    city: ensureString(normalizeField(raw, ['city'], '')),
    address1: ensureString(normalizeField(raw, ['address1'], '')),
    partyName: ensureString(normalizeField(raw, ['party_name'], '')),
    partyOrg: ensureString(normalizeField(raw, ['party_org'], '')),
    partyType: ensureString(normalizeField(raw, ['party_type', 'PartyType'], '')),
    partyCity: ensureString(normalizeField(raw, ['party_city'], '')),
    partyAddress1: ensureString(normalizeField(raw, ['party_address1'], '')),
    canDeassociate: parseBoolean(normalizeField(raw, ['canDeassociate'], false)),
    isActive: parseBoolean(normalizeField(raw, ['IsActive'], true)),
    expirationDate: normalizeField(raw, ['ExpirationDate'], null),
    expirationDateTz: normalizeField(raw, ['ExpirationDateTz'], null),
  };
};

export const normalizePartiesList = (response) => {
  if (!response || typeof response !== 'object') {
    return [];
  }
  validatePartiesResponse(response);
  const listData = normalizeField(response.Data || {}, ['Parties'], []);
  return ensureArray(listData).map(normalizePartyItem).filter(Boolean);
};

export const getPartiesTotal = (response) =>
  parseInteger(normalizeField(response || {}, ['Total'], 0), 0);
